module.exports = __webpack_public_path__ + "static/media/hussain.37c6fea6.png";